export default __webpack_public_path__ + "static/media/tripadvisor_main_black.562536b5.svg";